import React, { useState, useEffect, useCallback, useMemo, useContext, createContext } from 'react';
import { initializeApp } from 'firebase/app';
import { 
    getAuth, 
    onAuthStateChanged, 
    createUserWithEmailAndPassword, 
    signInWithEmailAndPassword, 
    signOut,
    sendPasswordResetEmail
} from 'firebase/auth';
import { 
    getFirestore, 
    doc, 
    setDoc, 
    getDoc, 
    collection, 
    addDoc, 
    query, 
    onSnapshot, 
    updateDoc, 
    deleteDoc,
    serverTimestamp,
    getDocs,
    limit,
    where
} from 'firebase/firestore';
import { 
    getStorage, 
    ref, 
    uploadString, 
    getDownloadURL 
} from 'firebase/storage';

// --- Configuration Firebase ---
const firebaseConfig = {
    apiKey: "AIzaSyAUXVpDS1jjiVkbugT1xSL00-zdyduVFNQ",
    authDomain: "jrb-evenements-3439d.firebaseapp.com",
    projectId: "jrb-evenements-3439d",
    storageBucket: "jrb-evenements-3439d.appspot.com",
    messagingSenderId: "327491891163",
    appId: "1:327491891163:web:bfcd8292e1aa450914c1fe"
};

const appId = typeof __app_id !== 'undefined' ? __app_id : 'default-app-id';

// --- Initialisation de Firebase ---
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// --- Icônes (SVG pour la simplicité) ---
const icons = {
  dashboard: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>,
  room: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>,
  tasks: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>,
  material: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.5 14.5L18 11l-4 4 4 4 3.5-3.5a2.12 2.12 0 0 0 0-3Z"></path><path d="M10.5 5.5L7 9l-4-4 4-4 3.5 3.5a2.12 2.12 0 0 1 0 3Z"></path><path d="m14.5 10.5 4-4"></path><path d="m5.5 19.5 4-4"></path></svg>,
  furniture: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"></path><path d="M4 15v-2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2"></path><path d="M2 15h20"></path><path d="M17 20v-5h-2v5"></path><path d="M9 20v-5H7v5"></path></svg>,
  personnel: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>,
  tariffs: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>,
  archives: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2.4-2.4-4.2-4.8-4.8-.9-.3-1.8-.5-2.7-.5-1.9 0-3.7.6-5.2 1.9l-1.9-1.9c-.4-.4-1-.4-1.4 0l-1.4 1.4c-.4.4-.4 1 0 1.4l1.9 1.9C2.6 12.3 2 14.1 2 16c0 1.9.6 3.7 1.9 5.2l1.9 1.9c.4.4 1 .4 1.4 0l1.4-1.4c-.4-.4.4-1 0-1.4l-1.9-1.9c1.5-1.3 3.3-1.9 5.2-1.9.9 0 1.8.2 2.7.5 2.4.6 4.2 2.4 4.8 4.8.3 1.3 0 2.7-.7 3.9l-1.5-1.5c-.4-.4-1-.4-1.4 0l-1.4 1.4c-.4.4-.4 1 0 1.4l1.5 1.5c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-1.5-1.5z"></path></svg>,
  settings: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 0 2l-.15.08a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.38a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1 0-2l.15-.08a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>,
  inventory: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>,
  lostFound: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>,
  logout: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>,
  ok: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>,
  attention: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="orange" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>,
  degraded: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="red" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>,
  lock: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>,
  eye: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>,
  fullscreen: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>,
  quit: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line></svg>,
};

// --- Composants Utilitaires ---
const LoadingSpinner = () => (
    <div className="flex justify-center items-center h-screen bg-gray-900 text-white">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
    </div>
);

const Modal = ({ children, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50">
        <div className="bg-gray-800 p-6 rounded-lg shadow-xl w-full max-w-md md:max-w-2xl max-h-[90vh] overflow-y-auto relative">
            <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-white">&times;</button>
            {children}
        </div>
    </div>
);

// --- Fonctions de Hook personnalisées pour les données ---
const useCollection = (collectionName) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const q = query(collection(db, `artifacts/${appId}/public/data/${collectionName}`));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                items.push({ id: doc.id, ...doc.data() });
            });
            setData(items);
            setLoading(false);
        }, (error) => {
            console.error(`Error fetching ${collectionName}: `, error);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [collectionName]);

    return { data, loading };
};

// --- Composants de l'interface Administrateur (Backend) ---

const AdminDashboard = ({ user, userData, onLogout, onSwitchView }) => {
    const [activeSection, setActiveSection] = useState('dashboard');
    const { data: archives } = useCollection('cleaning_archives');
    const { data: inventoryRequests } = useCollection('inventory_requests');

    const newArchivesCount = useMemo(() => archives.filter(a => !a.viewed).length, [archives]);
    const newInventoryCount = useMemo(() => inventoryRequests.filter(i => !i.viewed).length, [inventoryRequests]);

    const handleSectionClick = async (section) => {
        setActiveSection(section);
        if (section === 'archives' && newArchivesCount > 0) {
            archives.filter(a => !a.viewed).forEach(async (archive) => {
                await updateDoc(doc(db, `artifacts/${appId}/public/data/cleaning_archives`, archive.id), { viewed: true });
            });
        }
        if (section === 'inventory' && newInventoryCount > 0) {
            inventoryRequests.filter(i => !i.viewed).forEach(async (req) => {
                await updateDoc(doc(db, `artifacts/${appId}/public/data/inventory_requests`, req.id), { viewed: true });
            });
        }
    };

    const menuItems = [
        { id: 'dashboard', label: 'Tableau de Bord', icon: icons.dashboard },
        { id: 'rooms', label: 'Salles', icon: icons.room },
        { id: 'tasks', label: 'Tâches', icon: icons.tasks },
        { id: 'material', label: 'Matériel', icon: icons.material },
        { id: 'furniture', label: 'Meubles', icon: icons.furniture },
        { id: 'personnel', label: 'Personnel', icon: icons.personnel },
        { id: 'tariffs', label: 'Tarifs', icon: icons.tariffs },
        { id: 'archives', label: 'Ménage', icon: icons.archives, count: newArchivesCount },
        { id: 'inventory', label: 'Inventaire', icon: icons.inventory, count: newInventoryCount },
        { id: 'lostFound', label: 'Objets Perdus', icon: icons.lostFound },
        { id: 'settings', label: 'Réglages', icon: icons.settings },
    ];

    return (
        <div className="flex h-screen bg-gray-900 text-white">
            <aside className="w-64 bg-gray-800 p-4 flex flex-col">
                <h1 className="text-2xl font-bold mb-6 text-blue-400">Admin Panel</h1>
                <button onClick={onSwitchView} className="w-full flex items-center p-2 rounded-lg transition-colors bg-indigo-600 hover:bg-indigo-700 mb-4">
                    <span className="mr-3">{icons.eye}</span>
                    Passer en vue Agent
                </button>
                <nav className="flex-grow">
                    <ul>
                        {menuItems.map(item => (
                            <li key={item.id} className="mb-2">
                                <button
                                    onClick={() => handleSectionClick(item.id)}
                                    className={`w-full flex items-center p-2 rounded-lg transition-colors ${activeSection === item.id ? 'bg-blue-600' : 'hover:bg-gray-700'}`}
                                >
                                    <span className="mr-3">{item.icon}</span>
                                    <span className="flex-1 text-left">{item.label}</span>
                                    {item.count > 0 && <span className="bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">{item.count}</span>}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
                <button onClick={onLogout} className="w-full flex items-center p-2 rounded-lg transition-colors hover:bg-red-600 mt-4">
                    <span className="mr-3">{icons.logout}</span>
                    Déconnexion
                </button>
            </aside>
            <main className="flex-1 p-6 overflow-y-auto">
                {activeSection === 'dashboard' && <DashboardHome />}
                {activeSection === 'rooms' && <ManageGeneric collectionName="rooms" title="Salles" fields={{ name: 'text', accessCode: 'text' }} specialLogic="rooms" />}
                {activeSection === 'tasks' && <ManageGeneric collectionName="tasks" title="Tâches" fields={{ name: 'text', description: 'textarea' }} />}
                {activeSection === 'material' && <ManageGeneric collectionName="materials" title="Matériel de Ménage" fields={{ name: 'text', stock: 'number' }} />}
                {activeSection === 'furniture' && <ManageGeneric collectionName="furniture" title="Meubles" fields={{ name: 'text', quantity: 'number', type: 'select', roomId: 'select' }} specialLogic="furniture" />}
                {activeSection === 'personnel' && <ManagePersonnel />}
                {activeSection === 'tariffs' && <ManageGeneric collectionName="tariffs" title="Tarifs" fields={{ name: 'text', price: 'number' }} />}
                {activeSection === 'archives' && <ManageCleaning />}
                {activeSection === 'inventory' && <InventoryManagement />}
                {activeSection === 'lostFound' && <LostAndFoundAdmin />}
                {activeSection === 'settings' && <Settings />}
            </main>
        </div>
    );
};

// --- Sous-composants du Backend ---

const DashboardHome = () => {
    const { data: inventoryRequests } = useCollection('inventory_requests');
    const { data: lostItems } = useCollection('lost_and_found');
    const { data: furniture } = useCollection('furniture');
    
    const today = new Date().toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

    const spaAlerts = useMemo(() => {
        const alerts = [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        furniture
            .filter(f => f.name && f.name.toLowerCase() === 'spa')
            .forEach(spa => {
                if (spa.nextWaterChange && spa.nextWaterChange !== "Eau propre en attente de nouveau client") {
                    alerts.push({
                        id: `${spa.id}-water`,
                        spaName: spa.name,
                        spaType: spa.type || 'Public',
                        alertType: "Changement d'eau",
                        date: new Date(spa.nextWaterChange),
                    });
                } else if (spa.nextWaterChange) {
                     alerts.push({
                        id: `${spa.id}-water`,
                        spaName: spa.name,
                        spaType: spa.type || 'Public',
                        alertType: "Changement d'eau",
                        date: null, // Indicates waiting status
                    });
                }
                if (spa.nextMaintenance) {
                     alerts.push({
                        id: `${spa.id}-maintenance`,
                        spaName: spa.name,
                        spaType: spa.type || 'Public',
                        alertType: "Entretien machinerie",
                        date: new Date(spa.nextMaintenance),
                    });
                }
            });

        return alerts.sort((a, b) => (a.date || 0) - (b.date || 0));
    }, [furniture]);

    const getAlertColor = (date) => {
        if (!date) return 'bg-green-900/50';
        const today = new Date();
        today.setHours(0,0,0,0);
        return date < today ? 'bg-red-900/50' : 'bg-blue-900/50';
    }

    return (
        <div>
            <div className="bg-gray-800 p-6 rounded-lg mb-6 col-span-1 md:col-span-2 lg:col-span-3">
                <h3 className="text-xl font-semibold text-cyan-400 mb-4">Alertes SPA</h3>
                <div className="space-y-3">
                    {spaAlerts.length > 0 ? (
                        spaAlerts.map(alert => (
                            <div key={alert.id} className={`p-3 rounded-lg flex items-center justify-between ${getAlertColor(alert.date)}`}>
                                <div>
                                    <p className="font-bold">{alert.alertType}</p>
                                    <p className="text-sm text-gray-300">SPA: {alert.spaName} ({alert.spaType})</p>
                                </div>
                                <p className="font-semibold text-lg">
                                    {alert.date ? alert.date.toLocaleDateString('fr-FR') : "En attente de client"}
                                </p>
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-400">Aucune alerte à venir pour les SPAs.</p>
                    )}
                </div>
            </div>
            <h2 className="text-3xl font-bold mb-6">Tableau de Bord</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-blue-400">Date du Jour</h3>
                    <p className="text-2xl mt-2">{today}</p>
                </div>
                <div className="bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-yellow-400">Inventaire Urgent</h3>
                    <p className="text-3xl font-bold mt-2">{inventoryRequests.filter(i => i.priority === 'Haute').length}</p>
                    <p className="text-gray-400">demandes à traiter</p>
                </div>
                <div className="bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-green-400">Objets Perdus</h3>
                    <p className="text-3xl font-bold mt-2">{lostItems.filter(i => !i.boxNumber).length}</p>
                    <p className="text-gray-400">objets à référencer</p>
                </div>
            </div>
        </div>
    );
};

const ManageGeneric = ({ collectionName, title, fields, specialLogic }) => {
    const { data } = useCollection(collectionName);
    const { data: tasksList } = useCollection('tasks');
    const { data: materialsList } = useCollection('materials');
    const { data: roomsList } = useCollection('rooms');

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (currentItem) {
            const initialData = { ...currentItem };
            if (specialLogic === 'rooms') {
                initialData.tasks = initialData.tasks || [];
                initialData.materials = initialData.materials || [];
            }
            setFormData(initialData);
        } else {
            const initialFields = {};
            Object.keys(fields).forEach(key => {
                if (fields[key] === 'number') initialFields[key] = 0;
                else if (fields[key] === 'select' && key === 'type') initialFields[key] = 'Public';
                else if (fields[key] === 'select' && key === 'roomId') initialFields[key] = roomsList[0]?.id || '';
                else initialFields[key] = '';
            });
            if (specialLogic === 'rooms') {
                initialFields.tasks = [];
                initialFields.materials = [];
            }
            if (specialLogic === 'furniture' && initialFields.name?.toLowerCase() === 'spa') {
                initialFields.fillTime = '';
                initialFields.lastWaterChange = '';
                initialFields.lastMaintenance = '';
            }
            setFormData(initialFields);
        }
    }, [currentItem, fields, specialLogic, roomsList]);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setCurrentItem(null);
    };

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        const finalValue = type === 'number' ? parseFloat(value) : value;

        setFormData(prev => {
            const newState = { ...prev, [name]: finalValue };

            if (name === 'lastMaintenance' && value) {
                const nextDate = new Date(value);
                nextDate.setMonth(nextDate.getMonth() + 6);
                newState.nextMaintenance = nextDate.toISOString().split('T')[0];
            }

            if (name === 'lastWaterChange' && value) {
                const nextDate = new Date(value);
                nextDate.setDate(nextDate.getDate() + 6);
                newState.nextWaterChange = nextDate.toISOString().split('T')[0];
            }

            return newState;
        });
    };

    const handleMultiSelectChange = (name, selectedOptions) => {
        const values = Array.from(selectedOptions, option => option.value);
        setFormData(prev => ({ ...prev, [name]: values }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const collectionRef = collection(db, `artifacts/${appId}/public/data/${collectionName}`);
        try {
            if (currentItem) {
                await updateDoc(doc(collectionRef, currentItem.id), formData);
            } else {
                await addDoc(collectionRef, formData);
            }
            handleCloseModal();
        } catch (error) {
            console.error("Error saving document: ", error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer cet élément ?")) {
            try {
                await deleteDoc(doc(db, `artifacts/${appId}/public/data/${collectionName}`, id));
            } catch (error) {
                console.error("Error deleting document: ", error);
            }
        }
    };

    const renderSpecialFields = () => {
        if (specialLogic === 'rooms') {
            return (
                <>
                    <div className="mb-4">
                        <label className="block mb-2">Tâches à faire</label>
                        <select multiple name="tasks" value={formData.tasks || []} onChange={(e) => handleMultiSelectChange('tasks', e.target.selectedOptions)} className="w-full p-2 bg-gray-700 rounded h-32">
                            {tasksList.map(task => <option key={task.id} value={task.name}>{task.name}</option>)}
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block mb-2">Matériel nécessaire</label>
                        <select multiple name="materials" value={formData.materials || []} onChange={(e) => handleMultiSelectChange('materials', e.target.selectedOptions)} className="w-full p-2 bg-gray-700 rounded h-32">
                            {materialsList.map(mat => <option key={mat.id} value={mat.name}>{mat.name}</option>)}
                        </select>
                    </div>
                </>
            );
        }
        if (specialLogic === 'furniture' && formData.name?.toLowerCase() === 'spa') {
            return (
                <>
                    <div className="mb-4">
                        <label className="block mb-2">Temps de remplissage</label>
                        <input type="text" name="fillTime" value={formData.fillTime || ''} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded" />
                    </div>
                    <div className="mb-4">
                        <label className="block mb-2">Date du dernier changement d'eau</label>
                        <input type="date" name="lastWaterChange" value={formData.lastWaterChange || ''} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded" />
                    </div>
                    {formData.nextWaterChange && (
                        <div className="mb-4 p-3 bg-blue-900 rounded">
                            <p className="font-semibold">Prochain changement d'eau calculé :</p>
                            <p>{new Date(formData.nextWaterChange).toLocaleDateString('fr-FR')}</p>
                        </div>
                    )}
                    <div className="mb-4">
                        <label className="block mb-2">Date du dernier entretien machinerie</label>
                        <input type="date" name="lastMaintenance" value={formData.lastMaintenance || ''} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded" />
                    </div>
                    {formData.nextMaintenance && (
                        <div className="mb-4 p-3 bg-blue-900 rounded">
                            <p className="font-semibold">Prochain entretien calculé :</p>
                            <p>{new Date(formData.nextMaintenance).toLocaleDateString('fr-FR')}</p>
                        </div>
                    )}
                </>
            );
        }
        return null;
    };

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-bold">{title}</h2>
                <button onClick={() => handleOpenModal()} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Ajouter</button>
            </div>

            <div className="bg-gray-800 rounded-lg overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-gray-700">
                                {Object.keys(fields).map(key => <th key={key} className="p-4 capitalize">{key.replace(/([A-Z])/g, ' $1')}</th>)}
                                <th className="p-4">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(item => (
                                <tr key={item.id} className="border-b border-gray-700">
                                    {Object.keys(fields).map(key => <td key={key} className="p-4">{key === 'roomId' ? (roomsList.find(r => r.id === item[key])?.name || 'N/A') : (collectionName === 'tariffs' && key === 'price' ? `${item[key]} €` : item[key])}</td>)}
                                    <td className="p-4">
                                        <button onClick={() => handleOpenModal(item)} className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-1 px-3 rounded mr-2">Modifier</button>
                                        <button onClick={() => handleDelete(item.id)} className="bg-red-600 hover:bg-red-700 text-white font-bold py-1 px-3 rounded">Supprimer</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && (
                <Modal onClose={handleCloseModal}>
                    <h3 className="text-2xl font-bold mb-4">{currentItem ? 'Modifier' : 'Ajouter'} {title}</h3>
                    <form onSubmit={handleSubmit}>
                        {Object.keys(fields).map(key => (
                            <div key={key} className="mb-4">
                                <label htmlFor={key} className="block mb-2 capitalize">{key.replace(/([A-Z])/g, ' $1')}</label>
                                {fields[key] === 'textarea' ? (
                                    <textarea name={key} id={key} value={formData[key] || ''} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded" />
                                ) : fields[key] === 'select' && key === 'type' ? (
                                    <select name={key} id={key} value={formData[key] || 'Public'} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded">
                                        <option value="Public">Public</option>
                                        <option value="Nuptial">Nuptial</option>
                                    </select>
                                ) : fields[key] === 'select' && key === 'roomId' ? (
                                    <select name={key} id={key} value={formData[key] || ''} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded">
                                        <option value="">-- Sélectionner une salle --</option>
                                        {roomsList.map(room => <option key={room.id} value={room.id}>{room.name}</option>)}
                                    </select>
                                ) : (
                                    <input type={fields[key]} name={key} id={key} value={formData[key] || ''} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded" />
                                )}
                            </div>
                        ))}
                        {renderSpecialFields()}
                        <div className="flex justify-end">
                            <button type="button" onClick={handleCloseModal} className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-2">Annuler</button>
                            <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Enregistrer</button>
                        </div>
                    </form>
                </Modal>
            )}
        </div>
    );
};

const ManagePersonnel = () => {
    const { data: users } = useCollection('users');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({
        photo: '', nom: '', prenom: '', email: '', role: 'agent', password: ''
    });
    const [photoFile, setPhotoFile] = useState(null);
    const [photoPreview, setPhotoPreview] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (currentItem) {
            setFormData({ ...currentItem, password: '' });
            setPhotoPreview(currentItem.photo || '');
        } else {
            setFormData({ photo: '', nom: '', prenom: '', email: '', role: 'agent', password: '' });
            setPhotoPreview('');
        }
    }, [currentItem]);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setError('');
        setIsModalOpen(true);
    };
    
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setCurrentItem(null);
        setPhotoFile(null);
        setPhotoPreview('');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPhotoFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPhotoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!currentItem && formData.password.length < 6) {
            setError("Le mot de passe doit faire au moins 6 caractères.");
            return;
        }
        
        let photoUrl = currentItem ? currentItem.photo : `https://placehold.co/100x100/374151/E0E0E0?text=${formData.prenom.charAt(0)}`;

        if (photoFile) {
            const storageRef = ref(storage, `profile_pictures/${Date.now()}_${photoFile.name}`);
            const uploadResult = await uploadString(storageRef, photoPreview, 'data_url');
            photoUrl = await getDownloadURL(uploadResult.ref);
        }

        const userData = {
            nom: formData.nom,
            prenom: formData.prenom,
            email: formData.email,
            role: formData.role,
            photo: photoUrl,
        };

        if (currentItem) {
            await updateDoc(doc(db, `artifacts/${appId}/public/data/users`, currentItem.id), userData);
            handleCloseModal();
        } else {
            // Création d'un nouvel utilisateur par l'admin
            try {
                const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
                const user = userCredential.user;
                await setDoc(doc(db, `artifacts/${appId}/public/data/users`, user.uid), userData);
                handleCloseModal();
            } catch (err) {
                if (err.code === 'auth/email-already-in-use') {
                    setError("Cette adresse email est déjà utilisée.");
                } else {
                    setError("Erreur lors de la création du compte.");
                    console.error(err);
                }
            }
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Attention: supprimer un utilisateur est irréversible. L'utilisateur devra être supprimé manuellement de la section 'Authentication' de Firebase. Continuer ?")) {
            await deleteDoc(doc(db, `artifacts/${appId}/public/data/users`, id));
        }
    };
    
    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-bold">Gestion du Personnel</h2>
                <button onClick={() => handleOpenModal()} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Ajouter Personnel</button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {users.map(user => (
                    <div key={user.id} className="bg-gray-800 rounded-lg p-4 text-center">
                        <img src={user.photo} alt={`${user.prenom} ${user.nom}`} className="w-24 h-24 rounded-full mx-auto mb-4 object-cover" />
                        <h3 className="text-xl font-bold">{user.prenom} {user.nom}</h3>
                        <p className="text-gray-400">{user.email}</p>
                        <p className="bg-blue-500 text-white text-xs font-bold inline-block px-2 py-1 rounded-full mt-2 capitalize">{user.role}</p>
                        <div className="mt-4">
                            <button onClick={() => handleOpenModal(user)} className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-1 px-3 rounded mr-2 text-sm">Modifier</button>
                            <button onClick={() => handleDelete(user.id)} className="bg-red-600 hover:bg-red-700 text-white font-bold py-1 px-3 rounded text-sm">Supprimer</button>
                        </div>
                    </div>
                ))}
            </div>
            {isModalOpen && (
                <Modal onClose={handleCloseModal}>
                    <h3 className="text-2xl font-bold mb-4">{currentItem ? 'Modifier' : 'Ajouter'} un membre du personnel</h3>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block mb-2">Photo</label>
                            <input type="file" onChange={handleFileChange} className="w-full text-sm text-gray-400 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"/>
                            {photoPreview && <img src={photoPreview} alt="Aperçu" className="w-20 h-20 rounded-full mt-2 object-cover"/>}
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <input type="text" name="nom" value={formData.nom} onChange={handleChange} placeholder="Nom" required className="w-full p-2 bg-gray-700 rounded" />
                            <input type="text" name="prenom" value={formData.prenom} onChange={handleChange} placeholder="Prénom" required className="w-full p-2 bg-gray-700 rounded" />
                        </div>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email de connexion" required className="w-full p-2 bg-gray-700 rounded" disabled={!!currentItem} />
                        {!currentItem && (
                             <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Mot de passe initial" required className="w-full p-2 bg-gray-700 rounded" />
                        )}
                        <select name="role" value={formData.role} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded">
                            <option value="agent">Agent</option>
                            <option value="admin">Administrateur</option>
                        </select>
                        {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                        <div className="flex justify-end pt-4">
                            <button type="button" onClick={handleCloseModal} className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-2">Annuler</button>
                            <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Enregistrer</button>
                        </div>
                    </form>
                </Modal>
            )}
        </div>
    );
};

const ManageCleaning = () => {
    const { data: cleaningArchives } = useCollection('cleaning_archives');
    const { data: users } = useCollection('users');
    const [editingArchiveId, setEditingArchiveId] = useState(null);
    const [editedAgentId, setEditedAgentId] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

    const getUserName = (id) => {
        const user = users.find(u => u.id === id);
        return user ? `${user.prenom} ${user.nom}` : 'Inconnu';
    };

    const formatDuration = (milliseconds) => {
        if (!milliseconds || milliseconds < 0) return 'N/A';
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        return `${hours}h ${minutes}min`;
    };

    const { years, months } = useMemo(() => {
        const yearSet = new Set();
        const monthSet = new Set();
        cleaningArchives.forEach(archive => {
            if (archive.startTime) {
                const date = archive.startTime.toDate();
                yearSet.add(date.getFullYear());
                if(date.getFullYear() === selectedYear) {
                    monthSet.add(date.getMonth());
                }
            }
        });
        return { years: [...yearSet].sort((a,b) => b-a), months: [...monthSet].sort((a,b) => b-a) };
    }, [cleaningArchives, selectedYear]);

    const filteredArchives = useMemo(() => {
        return cleaningArchives
            .filter(archive => {
                if (!archive.startTime) return false;
                const date = archive.startTime.toDate();
                return date.getFullYear() === selectedYear && date.getMonth() === selectedMonth;
            })
            .sort((a, b) => b.startTime?.toMillis() - a.startTime?.toMillis());
    }, [cleaningArchives, selectedYear, selectedMonth]);
    
    const handleEditAgent = (archive) => {
        setEditingArchiveId(archive.id);
        setEditedAgentId(archive.agentId);
    };

    const handleSaveAgent = async (archiveId) => {
        await updateDoc(doc(db, `artifacts/${appId}/public/data/cleaning_archives`, archiveId), {
            agentId: editedAgentId
        });
        setEditingArchiveId(null);
    };

    const handleDeleteArchive = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer cette archive ? Cette action est irréversible.")) {
            await deleteDoc(doc(db, `artifacts/${appId}/public/data/cleaning_archives`, id));
        }
    };

    const generatePDF = (archive) => {
        const agentName = getUserName(archive.agentId);
        const statusText = {
            ok: 'Terminé - RAS',
            billing: 'Facturation requise',
            degraded: 'Dégradation majeure'
        }[archive.status] || 'Inconnu';

        const tariffsHtml = archive.tariffsApplied && archive.tariffsApplied.length > 0
            ? `<h3>Tarifs appliqués</h3><ul>${archive.tariffsApplied.map(t => `<li>${t}</li>`).join('')}</ul>`
            : '<p>Aucun tarif appliqué.</p>';
        
        const degradationsHtml = archive.degradations && archive.degradations.length > 0
            ? `<h3>Dégradations signalées</h3>
                ${archive.degradations.map(d => `
                    <div>
                        <p><strong>Description:</strong> ${d.description}</p>
                        ${d.photo ? `<img src="${d.photo}" alt="Photo de dégradation" style="max-width: 200px; border-radius: 4px; margin-top: 5px;" />` : ''}
                    </div>
                `).join('<hr style="margin: 10px 0;" />')}`
            : '';

        const content = `
            <html>
                <head>
                    <title>Rapport de Nettoyage - ${archive.roomName}</title>
                    <style>
                        body { font-family: sans-serif; margin: 2rem; }
                        h1, h2, h3 { color: #333; }
                        .report-container { border: 1px solid #ccc; padding: 1.5rem; border-radius: 8px; }
                        .report-header { border-bottom: 2px solid #eee; padding-bottom: 1rem; margin-bottom: 1rem; }
                        .report-item { margin-bottom: 0.75rem; }
                        .report-item strong { display: inline-block; width: 150px; }
                        ul { padding-left: 20px; }
                        li { margin-bottom: 5px; }
                    </style>
                </head>
                <body>
                    <div class="report-container">
                        <div class="report-header">
                            <h1>Rapport de Nettoyage</h1>
                        </div>
                        <h2>Détails de l'intervention</h2>
                        <div class="report-item"><strong>Date & Heure:</strong> ${archive.endTime ? new Date(archive.endTime.toDate()).toLocaleString('fr-FR') : 'N/A'}</div>
                        <div class="report-item"><strong>Salle:</strong> ${archive.roomName}</div>
                        <div class="report-item"><strong>Agent:</strong> ${agentName}</div>
                        <div class="report-item"><strong>Statut:</strong> ${statusText}</div>
                        <div class="report-item">
                            <strong>Commentaire:</strong>
                            <div>${archive.comment || 'Aucun commentaire.'}</div>
                        </div>
                        <hr>
                        ${tariffsHtml}
                        ${degradationsHtml}
                    </div>
                </body>
            </html>
        `;

        const newWindow = window.open('', '_blank');
        newWindow.document.write(content);
        newWindow.document.close();
        newWindow.focus();
        setTimeout(() => {
            newWindow.print();
            newWindow.close();
        }, 250);
    };

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-bold">Historique des Ménages</h2>
                <div className="flex gap-4">
                    <select value={selectedYear} onChange={e => setSelectedYear(Number(e.target.value))} className="bg-gray-700 p-2 rounded">
                        {years.map(year => <option key={year} value={year}>{year}</option>)}
                    </select>
                    <select value={selectedMonth} onChange={e => setSelectedMonth(Number(e.target.value))} className="bg-gray-700 p-2 rounded">
                        {months.map(month => <option key={month} value={month}>{new Date(0, month).toLocaleString('fr-FR', { month: 'long' })}</option>)}
                    </select>
                </div>
            </div>
            <div className="bg-gray-800 rounded-lg overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-gray-700">
                                <th className="p-4">Salle</th>
                                <th className="p-4">Agent</th>
                                <th className="p-4">Début</th>
                                <th className="p-4">Fin</th>
                                <th className="p-4">Durée</th>
                                <th className="p-4">Statut</th>
                                <th className="p-4">Détails</th>
                                <th className="p-4">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredArchives.map(archive => {
                                const duration = archive.endTime && archive.startTime ? archive.endTime.toMillis() - archive.startTime.toMillis() : 0;
                                const isEditing = editingArchiveId === archive.id;
                                return (
                                    <tr key={archive.id} className="border-b border-gray-700">
                                        <td className="p-4">{archive.roomName}</td>
                                        <td className="p-4">
                                            {isEditing ? (
                                                <select value={editedAgentId} onChange={e => setEditedAgentId(e.target.value)} className="bg-gray-700 p-1 rounded">
                                                    {users.map(user => <option key={user.id} value={user.id}>{user.prenom} {user.nom}</option>)}
                                                </select>
                                            ) : (
                                                getUserName(archive.agentId)
                                            )}
                                        </td>
                                        <td className="p-4">{archive.startTime ? new Date(archive.startTime.toDate()).toLocaleString('fr-FR') : 'N/A'}</td>
                                        <td className="p-4">{archive.endTime ? new Date(archive.endTime.toDate()).toLocaleString('fr-FR') : 'N/A'}</td>
                                        <td className="p-4">{formatDuration(duration)}</td>
                                        <td className="p-4">{icons[archive.status]}</td>
                                        <td className="p-4 max-w-xs truncate">{archive.comment}</td>
                                        <td className="p-4 flex gap-2">
                                            {isEditing ? (
                                                <>
                                                    <button onClick={() => handleSaveAgent(archive.id)} className="bg-green-600 hover:bg-green-700 text-white font-bold py-1 px-3 rounded">OK</button>
                                                    <button onClick={() => setEditingArchiveId(null)} className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-1 px-3 rounded">X</button>
                                                </>
                                            ) : (
                                                <button onClick={() => handleEditAgent(archive)} className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-1 px-3 rounded">Modifier</button>
                                            )}
                                            <button onClick={() => generatePDF(archive)} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded">PDF</button>
                                            <button onClick={() => handleDeleteArchive(archive.id)} className="bg-red-600 hover:bg-red-700 text-white font-bold py-1 px-3 rounded">Supprimer</button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const InventoryManagement = () => {
    const { data: inventoryRequests } = useCollection('inventory_requests');

    const updateStatus = async (id, status) => {
        await updateDoc(doc(db, `artifacts/${appId}/public/data/inventory_requests`, id), { status });
    };

    const handleDelete = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer cette demande ?")) {
            await deleteDoc(doc(db, `artifacts/${appId}/public/data/inventory_requests`, id));
        }
    };

    const getPriorityColor = (priority) => {
        switch (priority) {
            case 'Haute': return 'bg-red-500';
            case 'Moyenne': return 'bg-yellow-500';
            case 'Basse': return 'bg-green-500';
            default: return 'bg-gray-500';
        }
    };

    return (
        <div>
            <h2 className="text-3xl font-bold mb-6">Gestion de l'Inventaire</h2>
            <div className="bg-gray-800 rounded-lg overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-gray-700">
                                <th className="p-4">Date</th>
                                <th className="p-4">Produit</th>
                                <th className="p-4">Quantité</th>
                                <th className="p-4">Priorité</th>
                                <th className="p-4">Statut</th>
                                <th className="p-4">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                             {inventoryRequests.sort((a,b) => b.timestamp?.toMillis() - a.timestamp?.toMillis()).map(req => (
                                <tr key={req.id} className="border-b border-gray-700">
                                    <td className="p-4">{req.timestamp ? new Date(req.timestamp.toDate()).toLocaleString('fr-FR') : 'N/A'}</td>
                                    <td className="p-4">{req.productName}</td>
                                    <td className="p-4">{req.quantity}</td>
                                    <td className="p-4">
                                        <span className={`px-2 py-1 rounded-full text-xs font-bold ${getPriorityColor(req.priority)}`}>{req.priority}</span>
                                    </td>
                                    <td className="p-4 capitalize">{req.status || 'En attente'}</td>
                                    <td className="p-4 flex gap-2">
                                        <button onClick={() => updateStatus(req.id, 'À commander')} className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-1 px-3 rounded text-sm">À commander</button>
                                        <button onClick={() => updateStatus(req.id, 'Validé')} className="bg-green-600 hover:bg-green-700 text-white font-bold py-1 px-3 rounded text-sm">Validé</button>
                                        <button onClick={() => handleDelete(req.id)} className="bg-red-600 hover:bg-red-700 text-white font-bold py-1 px-3 rounded text-sm">Supprimer</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const LostAndFoundAdmin = () => {
    const { data: lostItems } = useCollection('lost_and_found');
    
    const updateBoxNumber = async (id, boxNumber) => {
        await updateDoc(doc(db, `artifacts/${appId}/public/data/lost_and_found`, id), { boxNumber });
    };

    const handleDelete = async (id) => {
        if (window.confirm("L'objet a été récupéré ? Confirmez la suppression.")) {
            await deleteDoc(doc(db, `artifacts/${appId}/public/data/lost_and_found`, id));
        }
    };

    const getDeletionDate = (timestamp) => {
        const date = new Date(timestamp.toDate());
        date.setFullYear(date.getFullYear() + 1);
        return date.toLocaleDateString('fr-FR');
    };

    return (
        <div>
            <h2 className="text-3xl font-bold mb-6">Objets Perdus</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {lostItems.map(item => (
                    <div key={item.id} className="bg-gray-800 rounded-lg p-4 flex flex-col">
                        {item.photoUrl && <img src={item.photoUrl} alt="Objet perdu" className="w-full h-48 object-cover rounded-md mb-4" />}
                        <p className="text-gray-400 text-sm">Trouvé le : {item.timestamp ? new Date(item.timestamp.toDate()).toLocaleString('fr-FR') : 'N/A'}</p>
                        <p className="font-bold mt-1">Salle: {item.roomName}</p>
                        <p className="flex-grow mt-2">{item.description}</p>
                        <div className="mt-4">
                            <input 
                                type="text"
                                placeholder="N° de boîte"
                                defaultValue={item.boxNumber || ''}
                                onBlur={(e) => updateBoxNumber(item.id, e.target.value)}
                                className="w-full p-2 bg-gray-700 rounded"
                            />
                        </div>
                        <p className="text-xs text-gray-500 mt-2 text-center">Sera supprimé le {getDeletionDate(item.timestamp)}</p>
                        <button onClick={() => handleDelete(item.id)} className="mt-2 bg-red-600 hover:bg-red-700 text-white font-bold py-1 px-3 rounded text-sm w-full">
                            Objet Récupéré (Supprimer)
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

const Settings = () => {
    const { data } = useCollection('settings');
    const [localSettings, setLocalSettings] = useState({ logo: '', siret: '', companyName: '' });
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState('');

    useEffect(() => {
        if (data.length > 0) {
            setLocalSettings(data[0]);
            setLogoPreview(data[0].logo || '');
        }
    }, [data]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPhotoFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setLogoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalSettings(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        let logoUrl = localSettings.logo;
        if (logoFile) {
            const storageRef = ref(storage, `settings/logo_${Date.now()}`);
            const uploadResult = await uploadString(storageRef, logoPreview, 'data_url');
            photoUrl = await getDownloadURL(uploadResult.ref);
        }
        
        const settingsToSave = {
            ...localSettings,
            logo: logoUrl,
        };
        
        await setDoc(doc(db, `artifacts/${appId}/public/data/settings`, 'main'), settingsToSave, { merge: true });
        alert("Réglages enregistrés !");
    };

    return (
        <div>
            <h2 className="text-3xl font-bold mb-6">Réglages</h2>
            <div className="bg-gray-800 p-6 rounded-lg max-w-lg">
                <div className="mb-6">
                    <label className="block mb-2 font-bold">Nom de la société</label>
                    <input type="text" name="companyName" value={localSettings.companyName || ''} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded" />
                </div>
                <div className="mb-6">
                    <label className="block mb-2 font-bold">Logo de l'entreprise</label>
                    <input type="file" accept="image/*" onChange={handleFileChange} className="w-full text-sm text-gray-400 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"/>
                    {logoPreview && <img src={logoPreview} alt="Logo" className="mt-4 h-24 bg-white p-2 rounded" />}
                </div>
                <div className="mb-6">
                    <label className="block mb-2 font-bold">Numéro SIRET</label>
                    <input type="text" name="siret" value={localSettings.siret || ''} onChange={handleChange} className="w-full p-2 bg-gray-700 rounded" />
                </div>
                <button onClick={handleSave} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Enregistrer les réglages</button>
                <div className="mt-6">
                    <label className="block mb-2 font-bold">Mise à jour de l'application</label>
                    <button onClick={() => alert("Vous utilisez la dernière version.")} className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">Vérifier les mises à jour</button>
                </div>
            </div>
        </div>
    );
};

// --- Composants de l'interface Agent (Frontend) ---

const AgentDashboard = ({ userData, onLogout, isAdminViewing, onSwitchView }) => {
    const [view, setView] = useState('home'); // home, cleaning, inventory, lostFound
    const [selectedRoom, setSelectedRoom] = useState(null);
    const { data: settings } = useCollection('settings');
    const companySettings = settings.find(s => s.id === 'main') || {};

    const handleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch(err => {
                console.error(`Erreur mode plein écran: ${err.message}`);
            });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };

    const handleQuit = async () => {
        await onLogout();
        try {
            window.open('about:blank', '_self').close();
        } catch (e) {
            console.error("Impossible de fermer la fenêtre:", e);
        }
    };

    const handleAcceptCleaning = async (room) => {
        if (!isAdminViewing) {
            const activeCleaningRef = doc(db, `artifacts/${appId}/public/data/active_cleanings`, room.id);
            try {
                await setDoc(activeCleaningRef, {
                    agentId: userData.id,
                    agentName: `${userData.prenom} ${userData.nom}`,
                    startTime: serverTimestamp(),
                    roomName: room.name
                });
            } catch (error) {
                console.error("Error starting cleaning session:", error);
                alert("Impossible de démarrer le nettoyage. Veuillez réessayer.");
                return;
            }
        }
        setSelectedRoom(room);
        setView('cleaning');
    };

    const handleFinishCleaning = () => {
        setSelectedRoom(null);
        setView('home');
    };

    return (
        <div className="bg-gray-900 text-white min-h-screen font-sans">
            <header className="bg-gray-800 p-4 flex justify-between items-center shadow-lg">
                {companySettings.logo ? <img src={companySettings.logo} alt="Logo" className="h-10"/> : <h1 className="text-xl font-bold text-blue-400">{companySettings.companyName || 'Panel Agent'}</h1>}
                <div className="flex items-center">
                    <div className="text-right mr-4">
                        <p className="font-bold">{userData.prenom} {userData.nom}</p>
                        <p className="text-sm text-gray-400">{isAdminViewing ? 'Admin (Vue Agent)' : 'Agent'}</p>
                    </div>
                    <img src={userData.photo} alt="Profil" className="w-12 h-12 rounded-full object-cover mr-4"/>
                    <div className="flex items-center gap-4">
                        <button onClick={handleFullScreen} title="Plein écran">{icons.fullscreen}</button>
                        {isAdminViewing ? (
                             <button onClick={onSwitchView} className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded text-sm">Retour Admin</button>
                        ) : (
                            <button onClick={handleQuit} title="Quitter l'application">{icons.quit}</button>
                        )}
                    </div>
                </div>
            </header>

            <nav className="flex justify-center bg-gray-800 border-t border-b border-gray-700">
                <button onClick={() => setView('home')} className={`p-4 ${view === 'home' ? 'text-blue-400 border-b-2 border-blue-400' : 'text-gray-300'}`}>Salles</button>
                <button onClick={() => setView('inventory')} className={`p-4 ${view === 'inventory' ? 'text-blue-400 border-b-2 border-blue-400' : 'text-gray-300'}`}>Inventaire</button>
                <button onClick={() => setView('lostFound')} className={`p-4 ${view === 'lostFound' ? 'text-blue-400 border-b-2 border-blue-400' : 'text-gray-300'}`}>Objet Perdu</button>
            </nav>

            <main className="p-4 md:p-6">
                {view === 'home' && <AgentHome onAcceptCleaning={handleAcceptCleaning} userData={userData} isAdminViewing={isAdminViewing} />}
                {view === 'cleaning' && selectedRoom && <CleaningTask room={selectedRoom} onFinish={handleFinishCleaning} userData={userData} isAdminViewing={isAdminViewing} />}
                {view === 'inventory' && <InventoryRequest userData={userData} />}
                {view === 'lostFound' && <LostAndFoundAgent userData={userData} />}
            </main>
        </div>
    );
};

// --- Sous-composants du Frontend ---

const AgentHome = ({ onAcceptCleaning, userData, isAdminViewing }) => {
    const { data: rooms } = useCollection('rooms');
    const { data: cleaningArchives } = useCollection('cleaning_archives');
    const { data: activeCleanings } = useCollection('active_cleanings');
    const { data: users } = useCollection('users');

    const formatDuration = (milliseconds) => {
        if (milliseconds < 0) return 'N/A';
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        return `${hours}h ${minutes}min`;
    };

    const cleaningHistory = useMemo(() => {
        return cleaningArchives
            .map(archive => {
                const agent = users.find(u => u.id === archive.agentId);
                const duration = archive.endTime && archive.startTime ? archive.endTime.toMillis() - archive.startTime.toMillis() : 0;
                return {
                    ...archive,
                    agentName: agent ? `${agent.prenom} ${agent.nom}` : 'Inconnu',
                    duration: formatDuration(duration)
                };
            })
            .sort((a, b) => b.startTime?.toMillis() - a.startTime?.toMillis());
    }, [cleaningArchives, users]);

    const cleanedToday = useMemo(() => {
        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);
        
        return cleaningArchives
            .filter(archive => 
                archive.endTime && 
                archive.endTime.toDate() > todayStart
            )
            .map(archive => archive.roomId);
    }, [cleaningArchives]);

    const { availableRooms, inProgressRooms, doneTodayRooms } = useMemo(() => {
        const available = [];
        const inProgress = [];
        const done = [];

        rooms.forEach(room => {
            const activeCleaning = activeCleanings.find(ac => ac.id === room.id);
            const isDone = cleanedToday.includes(room.id);

            if (isDone && !activeCleaning) {
                done.push(room);
            } else if (activeCleaning) {
                inProgress.push({ ...room, activeCleaning });
            } else {
                available.push(room);
            }
        });
        return { availableRooms: available, inProgressRooms: inProgress, doneTodayRooms: done };
    }, [rooms, activeCleanings, cleanedToday]);


    return (
        <div>
            {/* Salles en cours */}
            {inProgressRooms.length > 0 && (
                <>
                    <h2 className="text-2xl font-bold mb-4 text-yellow-400">Ménage en cours</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
                        {inProgressRooms.map(room => {
                             const isCurrentUserCleaning = room.activeCleaning.agentId === userData.id;
                             return (
                                <div key={room.id} className="bg-gray-800 p-4 rounded-lg flex flex-col justify-between border-2 border-yellow-500">
                                    <div>
                                        <h3 className="text-xl font-bold">{room.name}</h3>
                                        <p className="text-sm text-gray-400">{room.tasks?.length || 0} tâches</p>
                                    </div>
                                    <div className="mt-4">
                                        {isCurrentUserCleaning || isAdminViewing ? (
                                            <button onClick={() => onAcceptCleaning(room)} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">
                                                {isAdminViewing ? 'Voir' : 'Reprendre'}
                                            </button>
                                        ) : (
                                            <div className="flex items-center justify-center gap-2 text-yellow-400 p-2 bg-gray-700 rounded-lg">
                                                {icons.lock}
                                                <span>{room.activeCleaning.agentName}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </>
            )}
            
            {/* Salles disponibles */}
            <h2 className="text-2xl font-bold mb-4 text-blue-400">Salles disponibles</h2>
            {availableRooms.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {availableRooms.map(room => (
                        <div key={room.id} className="bg-gray-800 p-4 rounded-lg flex flex-col justify-between">
                             <div>
                                <h3 className="text-xl font-bold">{room.name}</h3>
                                <p className="text-sm text-gray-400">{room.tasks?.length || 0} tâches</p>
                            </div>
                            <button onClick={() => onAcceptCleaning(room)} className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                                {isAdminViewing ? 'Voir' : 'Accepter'}
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-gray-400">Aucune salle disponible pour le moment.</p>
            )}

            {/* Salles terminées */}
            {doneTodayRooms.length > 0 && (
                 <>
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-500">Salles terminées aujourd'hui</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {doneTodayRooms.map(room => (
                            <div key={room.id} className="bg-gray-700 p-4 rounded-lg flex flex-col justify-between opacity-60">
                                <div>
                                    <h3 className="text-xl font-bold text-gray-400">{room.name}</h3>
                                    <p className="text-sm text-gray-500">{room.tasks?.length || 0} tâches</p>
                                </div>
                                <button disabled className="mt-4 w-full bg-gray-500 text-white font-bold py-2 px-4 rounded cursor-not-allowed">
                                    Fait
                                </button>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <h2 className="text-2xl font-bold mt-8 mb-4">Historique des ménages</h2>
            <div className="bg-gray-800 rounded-lg overflow-x-auto">
                <table className="w-full text-left">
                    <thead>
                        <tr className="bg-gray-700">
                            <th className="p-4">Salle</th>
                            <th className="p-4">Agent</th>
                            <th className="p-4">Début</th>
                            <th className="p-4">Fin</th>
                            <th className="p-4">Durée</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cleaningHistory.map(archive => (
                            <tr key={archive.id} className="border-b border-gray-700">
                                <td className="p-4">{archive.roomName}</td>
                                <td className="p-4">{archive.agentName}</td>
                                <td className="p-4">{archive.startTime ? new Date(archive.startTime.toDate()).toLocaleString('fr-FR') : 'N/A'}</td>
                                <td className="p-4">{archive.endTime ? new Date(archive.endTime.toDate()).toLocaleString('fr-FR') : 'N/A'}</td>
                                <td className="p-4">{archive.duration}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const CleaningTask = ({ room, onFinish, userData, isAdminViewing }) => {
    const { data: tariffs } = useCollection('tariffs');
    const { data: furniture, loading: furnitureLoading } = useCollection('furniture');
    const [status, setStatus] = useState('ok');
    const [comment, setComment] = useState('');
    const [selectedTariffs, setSelectedTariffs] = useState([]);
    const [degradations, setDegradations] = useState([{ id: crypto.randomUUID(), description: '', photo: null, photoFile: null }]);
    const [isSpaModalOpen, setIsSpaModalOpen] = useState(false);
    const [completedTasks, setCompletedTasks] = useState([]);

    const spaInRoom = useMemo(() => {
        if (furnitureLoading) return null;
        return furniture.find(f => f.roomId === room.id && f.name.toLowerCase() === 'spa');
    }, [furniture, room.id, furnitureLoading]);

    const [spaData, setSpaData] = useState(null);
    useEffect(() => {
        setSpaData(spaInRoom);
    }, [spaInRoom]);

    const handleTaskToggle = (taskName) => {
        if (isAdminViewing) return;
        setCompletedTasks(prev => 
            prev.includes(taskName) 
                ? prev.filter(t => t !== taskName) 
                : [...prev, taskName]
        );
    };

    const handleWaterChange = async (changed) => {
        if (!spaData || isAdminViewing) return;
        
        let updatedSpaData;
        if (changed) {
            const today = new Date().toISOString().split('T')[0];
            updatedSpaData = { ...spaData, lastWaterChange: today, nextWaterChange: "Eau propre en attente de nouveau client" };
            await updateDoc(doc(db, `artifacts/${appId}/public/data/furniture`, spaData.id), {
                lastWaterChange: today,
                nextWaterChange: "Eau propre en attente de nouveau client",
            });
        } else {
            const currentNextChange = new Date(spaData.nextWaterChange);
            currentNextChange.setDate(currentNextChange.getDate() + 1);
            const newNextDateISO = currentNextChange.toISOString().split('T')[0];
            updatedSpaData = { ...spaData, nextWaterChange: newNextDateISO };
            await updateDoc(doc(db, `artifacts/${appId}/public/data/furniture`, spaData.id), {
                nextWaterChange: newNextDateISO,
            });
        }
        setSpaData(updatedSpaData);
        setIsSpaModalOpen(false);
    };

    const handleClientDeparture = async () => {
        if (!spaData || isAdminViewing) return;
        const today = new Date();
        const nextDate = new Date();
        nextDate.setDate(today.getDate() + 6);
        const todayISO = today.toISOString().split('T')[0];
        const nextDateISO = nextDate.toISOString().split('T')[0];
        
        const updatedSpaData = { ...spaData, lastWaterChange: todayISO, nextWaterChange: nextDateISO };
        await updateDoc(doc(db, `artifacts/${appId}/public/data/furniture`, spaData.id), {
            lastWaterChange: todayISO,
            nextWaterChange: nextDateISO,
        });
        setSpaData(updatedSpaData);
    };

    const handleDegradationChange = (id, field, value) => {
        setDegradations(degradations.map(d => d.id === id ? { ...d, [field]: value } : d));
    };

    const handleDegradationFileChange = (id, file) => {
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setDegradations(degradations.map(d => d.id === id ? { ...d, photo: reader.result, photoFile: file } : d));
            };
            reader.readAsDataURL(file);
        }
    };

    const addDegradation = () => {
        setDegradations([...degradations, { id: crypto.randomUUID(), description: '', photo: null, photoFile: null }]);
    };

    const removeDegradation = (id) => {
        setDegradations(degradations.filter(d => d.id !== id));
    };

    const handleTariffChange = (e) => {
        const values = Array.from(e.target.selectedOptions, option => option.value);
        setSelectedTariffs(values);
    };

    const handleSubmit = async () => {
        if (isAdminViewing) return;
        if (status !== 'ok' && !comment && status !== 'degraded') {
            alert("Veuillez ajouter un commentaire pour ce statut.");
            return;
        }
        if (status === 'degraded' && degradations.some(d => !d.description)) {
            alert("Veuillez remplir la description pour chaque dégradation signalée.");
            return;
        }

        const activeCleaningRef = doc(db, `artifacts/${appId}/public/data/active_cleanings`, room.id);
        const activeCleaningSnap = await getDoc(activeCleaningRef);

        if (!activeCleaningSnap.exists()) {
            alert("Erreur: session de nettoyage non trouvée.");
            return;
        }

        const startTime = activeCleaningSnap.data().startTime;

        let degradationsToSave = [];
        if (status === 'degraded') {
            for (const deg of degradations) {
                if (deg.description) {
                    let photoUrl = null;
                    if (deg.photo) {
                        const storageRef = ref(storage, `degradations/${Date.now()}_${deg.id}`);
                        const uploadResult = await uploadString(storageRef, deg.photo, 'data_url');
                        photoUrl = await getDownloadURL(uploadResult.ref);
                    }
                    degradationsToSave.push({ description: deg.description, photo: photoUrl });
                }
            }
        }

        await addDoc(collection(db, `artifacts/${appId}/public/data/cleaning_archives`), {
            agentId: userData.id,
            roomId: room.id,
            roomName: room.name,
            status,
            comment,
            tariffsApplied: selectedTariffs,
            degradations: degradationsToSave,
            viewed: false,
            startTime: startTime,
            endTime: serverTimestamp(),
        });

        await deleteDoc(activeCleaningRef);

        alert("Rapport envoyé !");
        onFinish();
    };

    return (
        <div className="bg-gray-800 p-6 rounded-lg max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-2">Nettoyage: {room.name}</h2>
            <p className="text-gray-400 mb-6">Code d'accès: <span className="font-mono bg-gray-700 px-2 py-1 rounded">{room.accessCode}</span></p>
            
            {isSpaModalOpen && (
                <Modal onClose={() => setIsSpaModalOpen(false)}>
                    <h3 className="text-2xl font-bold mb-4">Changement de l'eau du SPA</h3>
                    <p className="mb-6">L'eau du SPA a-t-elle été changée aujourd'hui ?</p>
                    <div className="flex justify-end gap-4">
                        <button onClick={() => handleWaterChange(true)} className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">Oui</button>
                        <button onClick={() => handleWaterChange(false)} className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">Non</button>
                    </div>
                </Modal>
            )}

            {spaData && (
                <div className="bg-blue-900/50 p-4 rounded-lg mb-6 border border-blue-700">
                    <h3 className="font-bold text-lg text-cyan-300">Info SPA</h3>
                     <div className="mt-2 text-sm space-y-1">
                        <p>Dernier changement: <span className="font-semibold">{spaData.lastWaterChange ? new Date(spaData.lastWaterChange).toLocaleDateString('fr-FR') : 'N/A'}</span></p>
                        <p>Prochain changement: <span className="font-semibold text-yellow-300">{spaData.nextWaterChange instanceof Date ? spaData.nextWaterChange.toLocaleDateString('fr-FR') : spaData.nextWaterChange}</span></p>
                    </div>
                    <div className="flex flex-wrap gap-2 mt-4">
                        <button onClick={handleClientDeparture} disabled={isAdminViewing} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-sm flex-grow disabled:opacity-50">
                            Départ Client (Changer l'eau)
                        </button>
                        <button onClick={() => setIsSpaModalOpen(true)} disabled={isAdminViewing} className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded text-sm flex-grow disabled:opacity-50">
                            Pas de client
                        </button>
                    </div>
                </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <h3 className="text-xl font-bold mb-3 border-b border-gray-600 pb-2">Tâches à faire</h3>
                    <div className="space-y-3">
                        {room.tasks?.map(task => (
                            <div key={task} className="flex items-center">
                                <input 
                                    type="checkbox"
                                    id={`task-${task}`}
                                    checked={completedTasks.includes(task)}
                                    onChange={() => handleTaskToggle(task)}
                                    disabled={isAdminViewing}
                                    className="w-5 h-5 text-blue-600 bg-gray-700 border-gray-600 rounded focus:ring-blue-500"
                                />
                                <label 
                                    htmlFor={`task-${task}`}
                                    className={`ml-3 text-white ${completedTasks.includes(task) ? 'line-through text-gray-500' : ''}`}
                                >
                                    {task}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-bold mb-3 border-b border-gray-600 pb-2">Matériel nécessaire</h3>
                    <ul className="list-disc list-inside space-y-2">
                        {room.materials?.map(material => <li key={material}>{material}</li>)}
                    </ul>
                </div>
            </div>

            <div className="mt-8 border-t border-gray-700 pt-6">
                <h3 className="text-xl font-bold mb-3">Finaliser le nettoyage</h3>
                <div className="flex flex-wrap gap-4 mb-4">
                    <button onClick={() => setStatus('ok')} disabled={isAdminViewing} className={`px-4 py-2 rounded font-semibold ${status === 'ok' ? 'bg-green-600' : 'bg-gray-600'} disabled:opacity-50`}>Terminé - RAS</button>
                    <button onClick={() => setStatus('billing')} disabled={isAdminViewing} className={`px-4 py-2 rounded font-semibold ${status === 'billing' ? 'bg-yellow-500' : 'bg-gray-600'} disabled:opacity-50`}>Facturation requise</button>
                    <button onClick={() => setStatus('degraded')} disabled={isAdminViewing} className={`px-4 py-2 rounded font-semibold ${status === 'degraded' ? 'bg-red-600' : 'bg-gray-600'} disabled:opacity-50`}>Dégradation majeure</button>
                </div>
                {status !== 'ok' && (
                    <div className="space-y-4">
                        <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Ajoutez un commentaire général..." className="w-full p-2 bg-gray-700 rounded h-24" disabled={isAdminViewing}></textarea>
                        {status === 'billing' && (
                             <div>
                                <label className="block mb-2">Sélectionner les tarifs applicables (maintenir Ctrl/Cmd pour plusieurs)</label>
                                <select multiple value={selectedTariffs} onChange={handleTariffChange} className="w-full p-2 bg-gray-700 rounded h-32" disabled={isAdminViewing}>
                                    {tariffs.map(tariff => (
                                        <option key={tariff.id} value={`${tariff.name} - ${tariff.price}€`}>
                                            {tariff.name} ({tariff.price}€)
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {status === 'degraded' && (
                            <div>
                                <label className="block mb-2">Signaler les dégradations</label>
                                {degradations.map((deg, index) => (
                                    <div key={deg.id} className="bg-gray-700/50 p-3 rounded-lg mb-3 space-y-2">
                                        <textarea value={deg.description} onChange={(e) => handleDegradationChange(deg.id, 'description', e.target.value)} placeholder={`Description de la dégradation #${index + 1}`} className="w-full p-2 bg-gray-600 rounded" disabled={isAdminViewing} />
                                        <input type="file" accept="image/*" onChange={(e) => handleDegradationFileChange(deg.id, e.target.files[0])} className="w-full text-sm text-gray-400 file:mr-4 file:py-1 file:px-2 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" disabled={isAdminViewing}/>
                                        {deg.photo && <img src={deg.photo} alt="Aperçu" className="w-24 h-24 object-cover rounded mt-1"/>}
                                        {degradations.length > 1 && <button type="button" onClick={() => removeDegradation(deg.id)} className="text-red-400 text-xs hover:text-red-300" disabled={isAdminViewing}>Supprimer cette ligne</button>}
                                    </div>
                                ))}
                                <button type="button" onClick={addDegradation} className="mt-2 text-blue-400 hover:text-blue-300 text-sm" disabled={isAdminViewing}>+ Ajouter une autre dégradation</button>
                            </div>
                        )}
                    </div>
                )}
                <div className="flex gap-4 mt-4">
                    <button onClick={handleSubmit} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded disabled:opacity-50" disabled={isAdminViewing}>Valider</button>
                    <button onClick={onFinish} className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-6 rounded">Annuler</button>
                </div>
            </div>
        </div>
    );
};

const InventoryRequest = ({ userData }) => {
    const { data: inventoryRequests } = useCollection('inventory_requests');
    const [productName, setProductName] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [priority, setPriority] = useState('Moyenne');

    const userHistory = useMemo(() => {
        return inventoryRequests.filter(h => h.agentId === userData.id).sort((a,b) => b.timestamp?.toMillis() - a.timestamp?.toMillis());
    }, [inventoryRequests, userData.id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        await addDoc(collection(db, `artifacts/${appId}/public/data/inventory_requests`), {
            agentId: userData.id,
            productName,
            quantity: parseInt(quantity, 10),
            priority,
            status: 'En attente',
            viewed: false,
            timestamp: serverTimestamp(),
        });
        alert("Demande envoyée !");
        setProductName('');
        setQuantity(1);
    };
    
    const handleAcknowledge = async (id) => {
        await deleteDoc(doc(db, `artifacts/${appId}/public/data/inventory_requests`, id));
    };

    return (
        <div className="max-w-4xl mx-auto">
            <div className="bg-gray-800 p-6 rounded-lg mb-6">
                <h2 className="text-2xl font-bold mb-4">Demande de produit ou matériel</h2>
                <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                    <div className="md:col-span-2">
                        <label className="block mb-1">Nom du produit</label>
                        <input type="text" value={productName} onChange={e => setProductName(e.target.value)} required className="w-full p-2 bg-gray-700 rounded" />
                    </div>
                    <div>
                        <label className="block mb-1">Quantité</label>
                        <input type="number" value={quantity} onChange={e => setQuantity(e.target.value)} min="1" required className="w-full p-2 bg-gray-700 rounded" />
                    </div>
                    <div>
                        <label className="block mb-1">Priorité</label>
                        <select value={priority} onChange={e => setPriority(e.target.value)} className="w-full p-2 bg-gray-700 rounded">
                            <option>Basse</option>
                            <option>Moyenne</option>
                            <option>Haute</option>
                        </select>
                    </div>
                    <button type="submit" className="md:col-start-4 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full">Envoyer</button>
                </form>
            </div>
            
            <div className="bg-gray-800 p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-4">Historique de vos demandes</h3>
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="border-b border-gray-700">
                                <th className="p-2">Date</th>
                                <th className="p-2">Produit</th>
                                <th className="p-2">Quantité</th>
                                <th className="p-2">Statut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userHistory.map(req => (
                                <tr key={req.id}>
                                    <td className="p-2 text-sm text-gray-400">{req.timestamp ? new Date(req.timestamp.toDate()).toLocaleDateString('fr-FR') : ''}</td>
                                    <td className="p-2">{req.productName}</td>
                                    <td className="p-2">{req.quantity}</td>
                                    <td className="p-2 capitalize">
                                        {req.status === 'Validé' ? (
                                            <div className="flex items-center gap-2">
                                                <span>Reçu</span>
                                                <button onClick={() => handleAcknowledge(req.id)} className="bg-green-600 hover:bg-green-700 text-white font-bold py-1 px-2 rounded text-xs">
                                                    Message lu
                                                </button>
                                            </div>
                                        ) : (
                                            req.status
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const LostAndFoundAgent = ({ userData }) => {
    const { data: rooms } = useCollection('rooms');
    const { data: lostItems } = useCollection('lost_and_found');
    const [description, setDescription] = useState('');
    const [photo, setPhoto] = useState(null);
    const [roomName, setRoomName] = useState('');

    const userHistory = useMemo(() => {
        return lostItems
            .filter(item => item.agentId === userData.id)
            .sort((a, b) => b.timestamp?.toMillis() - a.timestamp?.toMillis());
    }, [lostItems, userData.id]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPhoto(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!roomName) {
            alert("Veuillez sélectionner la salle.");
            return;
        }

        let photoUrl = null;
        if (photo) {
            const storageRef = ref(storage, `lost_and_found/${Date.now()}`);
            const uploadResult = await uploadString(storageRef, photo, 'data_url');
            photoUrl = await getDownloadURL(uploadResult.ref);
        }

        await addDoc(collection(db, `artifacts/${appId}/public/data/lost_and_found`), {
            agentId: userData.id,
            description,
            photoUrl,
            roomName,
            timestamp: serverTimestamp(),
        });
        alert("Objet perdu signalé !");
        setDescription('');
        setPhoto(null);
        setRoomName('');
    };

    return (
        <div className="max-w-4xl mx-auto">
            <div className="bg-gray-800 p-6 rounded-lg mb-6">
                <h2 className="text-2xl font-bold mb-4">Signaler un objet perdu</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block mb-1">Salle</label>
                        <select value={roomName} onChange={e => setRoomName(e.target.value)} required className="w-full p-2 bg-gray-700 rounded">
                            <option value="">Sélectionner une salle</option>
                            {rooms.map(r => <option key={r.id} value={r.name}>{r.name}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block mb-1">Description de l'objet</label>
                        <textarea value={description} onChange={e => setDescription(e.target.value)} required className="w-full p-2 bg-gray-700 rounded h-24"></textarea>
                    </div>
                    <div>
                        <label className="block mb-1">Photo (optionnel)</label>
                        <input type="file" accept="image/*" onChange={handleFileChange} className="w-full text-sm text-gray-400 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"/>
                        {photo && <img src={photo} alt="Aperçu" className="w-32 h-32 object-cover rounded mt-2"/>}
                    </div>
                    <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Signaler</button>
                </form>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-4">Historique de vos objets trouvés</h3>
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="border-b border-gray-700">
                                <th className="p-2">Date</th>
                                <th className="p-2">Salle</th>
                                <th className="p-2">Description</th>
                                <th className="p-2">Photo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userHistory.length === 0 ? (
                                <tr><td colSpan="4" className="text-center p-4 text-gray-400">Aucun objet trouvé pour le moment.</td></tr>
                            ) : (
                                userHistory.map(item => (
                                    <tr key={item.id} className="border-b border-gray-700">
                                        <td className="p-2 text-sm text-gray-400">{item.timestamp ? new Date(item.timestamp.toDate()).toLocaleDateString('fr-FR') : ''}</td>
                                        <td className="p-2">{item.roomName}</td>
                                        <td className="p-2">{item.description}</td>
                                        <td className="p-2">
                                            {item.photoUrl ? <img src={item.photoUrl} alt="Objet trouvé" className="w-16 h-16 object-cover rounded"/> : 'N/A'}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};


// --- Composant de Connexion ---
const LoginScreen = () => {
    const [isResetMode, setIsResetMode] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const loginError = sessionStorage.getItem('loginError');
        if (loginError) {
            setError(loginError);
            sessionStorage.removeItem('loginError');
        }
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (err) {
            switch (err.code) {
                case 'auth/user-not-found':
                case 'auth/wrong-password':
                case 'auth/invalid-credential':
                    setError("Email ou mot de passe incorrect.");
                    break;
                default:
                    setError("Une erreur est survenue lors de la connexion.");
                    console.error(err);
            }
        }
    };

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            await sendPasswordResetEmail(auth, email);
            setMessage("Si un compte existe pour cet email, un lien de réinitialisation a été envoyé.");
        } catch (error) {
            setError("Erreur lors de l'envoi de l'email de réinitialisation.");
            console.error(error);
        }
    };

    if (isResetMode) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-900">
                <div className="w-full max-w-md p-8 space-y-8 bg-gray-800 rounded-lg shadow-lg">
                    <div>
                        <h2 className="text-3xl font-extrabold text-center text-white">Mot de passe oublié</h2>
                    </div>
                    <form className="mt-8 space-y-6" onSubmit={handlePasswordReset}>
                        <input name="email" type="email" autoComplete="email" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-700 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Adresse email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        {error && <p className="text-red-500 text-sm text-center mt-2">{error}</p>}
                        {message && <p className="text-green-500 text-sm text-center mt-2">{message}</p>}
                        <div>
                            <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                Envoyer le lien
                            </button>
                        </div>
                        <div className="text-sm text-center">
                            <button type="button" onClick={() => setIsResetMode(false)} className="font-medium text-blue-400 hover:text-blue-300">
                                Retour à la connexion
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center h-screen bg-gray-900">
            <div className="w-full max-w-md p-8 space-y-8 bg-gray-800 rounded-lg shadow-lg">
                <div>
                    <h2 className="text-3xl font-extrabold text-center text-white">
                        Connexion
                    </h2>
                </div>
                <form className="mt-8 space-y-6" onSubmit={handleLogin}>
                    <div className="rounded-md shadow-sm">
                        <input name="email" type="email" autoComplete="email" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-700 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm mb-4" placeholder="Adresse email (pseudo)" value={email} onChange={(e) => setEmail(e.target.value)} />
                        <input name="password" type="password" autoComplete="current-password" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-700 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div className="flex items-center justify-end text-sm">
                        <button type="button" onClick={() => setIsResetMode(true)} className="font-medium text-blue-400 hover:text-blue-300">
                            Mot de passe oublié ?
                        </button>
                    </div>
                    {error && <p className="text-red-500 text-sm text-center mt-2">{error}</p>}
                    {message && <p className="text-green-500 text-sm text-center mt-2">{message}</p>}
                    <div>
                        <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                            Se connecter
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};


// --- Composant Principal de l'Application ---
const AppCore = () => {
    const [user, setUser] = useState(null);
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [viewAs, setViewAs] = useState(null); // 'agent' or null

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            setLoading(true);
            if (currentUser) {
                const userDocRef = doc(db, `artifacts/${appId}/public/data/users`, currentUser.uid);
                
                const findUserDoc = async (retries = 5) => {
                    for (let i = 0; i < retries; i++) {
                        try {
                            const userDoc = await getDoc(userDocRef);
                            if (userDoc.exists()) {
                                return userDoc;
                            }
                        } catch (error) {
                            console.error("Error getting user doc:", error);
                        }
                        console.log(`User doc not found, retrying... (${i + 1})`);
                        await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
                    }
                    return null;
                };

                const userDoc = await findUserDoc();

                if (userDoc && userDoc.exists()) {
                    setUser(currentUser);
                    setUserData({ id: userDoc.id, ...userDoc.data() });
                } else {
                    console.error("User exists in Auth but not in Firestore after multiple retries:", currentUser.uid);
                    sessionStorage.setItem('loginError', 'Les données de votre profil sont introuvables. Veuillez contacter un administrateur.');
                    await signOut(auth);
                    setUser(null);
                    setUserData(null);
                }
            } else {
                setUser(null);
                setUserData(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const handleLogout = async () => {
        await signOut(auth);
    };

    if (loading) {
        return <LoadingSpinner />;
    }

    if (!user || !userData) {
        return <LoginScreen />;
    }

    const isAdmin = userData.role === 'admin';

    if (isAdmin && viewAs !== 'agent') {
        return <AdminDashboard user={user} userData={userData} onLogout={handleLogout} onSwitchView={() => setViewAs('agent')} />;
    }

    if ((isAdmin && viewAs === 'agent') || !isAdmin) {
        return <AgentDashboard user={user} userData={userData} onLogout={handleLogout} isAdminViewing={isAdmin} onSwitchView={isAdmin ? () => setViewAs(null) : null} />;
    }

    return <LoginScreen />;
}

export default function App() {
    return <AppCore />;
}
